import React from 'react';
import moment from 'moment';
import _ from 'underscore';

import FilterIcon from 'components/v2/icons/FilterIcon';
import Badge from 'components/v2/Badge';
import { humanize, titleize } from 'underscore.string';
import { getCustomerName } from './helpers';

/*
 * An active filters component
 */

export default function ActiveFilters({ query, onRemove, onClear }) {
  const active = [];

  _.map(query, (value, key) => {
    if (value && value !== undefined) {
      if (key === 'window_start') {
        active.push({
          code: 1,
          component: (
            <Badge
              key={1}
              withRemove
              onRemove={() =>
                onRemove('window_start', { window_start: undefined })
              }
              color="blue"
            >
              {`Start: ${moment(value).format('MM-DD-YYYY')}`}
            </Badge>
          ),
        });
      } else if (key === 'window_end') {
        active.push({
          code: 2,
          component: (
            <Badge
              key={2}
              withRemove
              onRemove={() => onRemove('window_end', { window_end: undefined })}
              color="blue"
            >
              {`End: ${moment(value).format('MM-DD-YYYY')}`}
            </Badge>
          ),
        });
      } else if (key === 'yard') {
        value.forEach((l) => {
          active.push({
            code: 10,
            component: (
              <Badge
                key={10}
                withRemove
                onRemove={() => onRemove('yard_remove', value, l._id)}
                color="yellow"
              >
                {`Yard: ${titleize(l.name)}`}
              </Badge>
            ),
          });
        });
      } else if (key === 'status') {
        value.forEach((s) => {
          active.push({
            code: 20,
            component: (
              <Badge
                key={20}
                withRemove
                onRemove={() => onRemove('status_remove', value, s.slug)}
                color="purple"
              >
                {`Status: ${titleize(s.slug)}`}
              </Badge>
            ),
          });
        });
      } else if (key === 'container_number') {
        value.forEach((c) => {
          active.push({
            code: 25,
            component: (
              <Badge
                key={25}
                withRemove
                onRemove={() => onRemove('container_remove', value, c)}
                color="yellow"
              >
                {`Container: ${c}`}
              </Badge>
            ),
          });
        });
      } else if (key === 'master_bill_number') {
        value.forEach((m) => {
          active.push({
            code: 25,
            component: (
              <Badge
                key={`master_bill_number-${m}`}
                withRemove
                onRemove={() => onRemove('master_bill_remove', value, m)}
                color="yellow"
              >
                {`Master Bill: ${m}`}
              </Badge>
            ),
          });
        });
      } else if (key === 'consignee') {
        value.forEach((c) => {
          active.push({
            code: 30,
            component: (
              <Badge
                key={`consignee-${c._id}`}
                withRemove
                onRemove={() => onRemove('consignee_remove', value, c._id)}
                color="pink"
              >
                {`Consignee: ${titleize(getCustomerName(c))}`}
              </Badge>
            ),
          });
        });
      } else if (key === 'shipper') {
        value.forEach((s) => {
          active.push({
            code: 40,
            component: (
              <Badge
                key={`shipper-${s._id}`}
                withRemove
                onRemove={() => onRemove('shipper_remove', value, s._id)}
                color="green"
              >
                {`Shipper: ${titleize(getCustomerName(s))}`}
              </Badge>
            ),
          });
        });
      } else if (key === 'carrier') {
        value.forEach((c) => {
          active.push({
            code: 50,
            component: (
              <Badge
                key={`carrier-${c._id}`}
                withRemove
                onRemove={() => onRemove('carrier_remove', value, c._id)}
                color="blue"
              >
                {`Carrier: ${titleize(getCustomerName(c))}`}
              </Badge>
            ),
          });
        });
      } else if (key === 'sortBy') {
        active.push({
          code: 100,
          component: (
            <Badge
              key="sort_by_remove"
              withRemove
              onRemove={() => onRemove('sort_by_remove')}
              color="red"
            >
              {`Sorted By: ${titleize(
                humanize(value),
              )} ${query.sortOrder.toUpperCase()}`}
            </Badge>
          ),
        });
      }
    }
  });

  if (active && active.length > 0) {
    active.push({
      code: 150,
      component: (
        <button className="text-xs text-blue" onClick={onClear} key="clear-all">
          [Clear All Filters]
        </button>
      ),
    });
  }

  const activeFilters = _.sortBy(active, 'code').map((a) => a.component);

  return (
    <div className="p-4">
      <div className="flex flex-wrap space-x-2 space-y-2">
        <FilterIcon className="mt-1 w-6 h-6 text-green" />
        <label className="form-label">Sorting </label>
        {activeFilters}
      </div>
    </div>
  );
}
